import axios from 'axios'
import { SignUpRequestData } from 'src/business/model/sign-up-data'

class SignUpService {
  baseUrl = '/api/auth/v2'

  async registerHaulier(data: SignUpRequestData): Promise<any> {
    const response = await axios.post(`${this.baseUrl}/tenants/haulier/register`, data)
    return response.data
  }
}

export const signUpService = new SignUpService()
